module.exports = __webpack_public_path__ + "img/28b-produtividade-pontos-avulso.7964d95c.png";